<template>
	<div>
		<template v-if="device!='pc'">
			<phonebox v-if="boxShow" code="onlinegoods" :ref="boxRef" title="线上商品" :width="1000" :index="2" moduleName="goods" @hide="hide"
				@submit="submit" group="offer_goods" :store="store" selectType="checkbox" :autoLoad="false" />
		</template>
		<template v-else>
			<box v-if="boxShow" code="onlinegoods" :ref="boxRef" title="线上商品" :width="1000" :index="2" moduleName="goods" @hide="hide"
				@submit="submit" group="offer_goods" :store="store" selectType="checkbox" :loading="loading" :autoLoad="false" />
		</template>
	</div>
</template>
<style scoped>
	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	}
</style>
<script>
	//https://detail.tmall.com/item.htm?id=706822484836&spm=a21dvs.23580594.0.0.1d293d0d88sla5 
	import box from '@_system/components/formcomponents/common/box/index.vue'
	import phonebox from '@_system/components/formcomponents/phone/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			form: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				loading:false,
				input: '',
				onlinegoodsidShow: false,
				
				//foreingKey:{onlineid:'718494299519'},
				// foreingKey: {
				// 	onlineid: '618277258500'
				// },
				foreingKey: {},
				boxShow: false,
				boxRef: 'box_' + Math.random(),
				box: null,
				device: window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			// this.foreingKey =  {
			// 	onlineid: this.input
			// }
			this.boxShow = true
			this.$nextTick(() => {
				let box = this.$refs[this.boxRef]
				box.buttonShow = false
				box.ready = () => {
					box.alertBox()
				}
				box.list = this.list
				box.checkMethod = this.checkMethod
				box.toolbarButtonClickEvent = this.toolbarButtonClickEvent
				box.beforeRequest = this.beforeRequest
				this.box = box
			})
		},
		watch: {

		},
		computed: {

		},

		methods: {
			list(page, form) {
				return new Promise((resolve) => {
					this.$api.goodsonline.list({
						mode: 'box',
						...page,
						...form,
						...this.foreingKey
					}).then((res) => {
						resolve(res)
					},()=>{
						resolve()
					})
				},()=>{
					this.loading = false
				})
			},
			beforeRequest(form) {
				if (form.onlineid) {
					let obj = this.checkUrl(form.onlineid)
					if (obj.id) {
						form.onlineid = obj.id
					}
					if (obj.skuId) {
						form.skuid = obj.skuId
					}
				}
			},
			// checkMethod({
			// 	row
			// }) {
			// 	return row.isparent === 1 && row.childrennum > 0 || row.isparent !== 1
			// },
			submit(e) {
	
				let data = []
				let sourcedata = e.data
				sourcedata.forEach((item) => {
					if (item.issuit==5) {
						if(item.isparent != 1){
							// item.name = item.name
							// item.model = item.model
							//item.unit = 254
							data.push(item)
						}
					}else{
						if(item.isparent!=1){
							item.name = item.groupname
							//item.model = item.groupname
							data.push(item)
						}
					}
				})
				//console.log(sourcedata,data,123123)
				this.$emit('submit', {
					data: data
				})
		

			},
			toolbarButtonClickEvent(e) {
				
				if (e.code == 'pull') {
					let code = this.box.getTable().getCheckboxRecords()
		
					let codes = []
					code.forEach((item) => {
						codes.push(item.groupcode)
					})
					let uniqueCodes = codes.filter((item, index) => {
						return codes.indexOf(item) === index
					})
					if (uniqueCodes.length != 0) {
						e.button.disabled = true
						e.button.icon = 'el-icon-loading'
						this.$api.goodsonline.pull({
							codes: uniqueCodes.join(','),
						}).then(() => {
							e.button.disabled = false
							e.button.icon = ''
							this.box.getTable().commitProxy('query')
						}, () => {
							e.button.disabled = false
							e.button.icon = ''
							//this.$message.error('万里牛超时接口超时，同步失败')
						})
						// if (uniqueCodes.length == 1) {
						// 	e.button.disabled = true
						// 	e.button.icon = 'el-icon-loading'
						// 	this.$api.goodsonline.pull({
						// 		codes: uniqueCodes.join(','),
						// 	}).then(() => {
						// 		e.button.disabled = false
						// 		e.button.icon = ''
						// 		this.box.getTable().commitProxy('query')
						// 	}, () => {
						// 		e.button.disabled = false
						// 		e.button.icon = ''
						// 		this.$message.error('万里牛超时接口超时，同步失败')
						// 	})
						// } else {
						// 	this.$message.error('一次只能同步一个')
						// }
					} else {

						this.$message.error('请选择组合编码')
					}

				}

			},
			// submitid() {
			// 	this.onlinegoodsidShow = false
			// 	this.foreingKey =  {
			// 		onlineid: this.input
			// 	}
			// 	this.boxShow = true
			// 	this.$nextTick(()=>{
			// 		let box = this.$refs[this.boxRef]
			// 		box.ready = () => {
			// 			box.alertBox()
			// 		}
			// 		box.list = this.list
			// 		box.checkMethod = this.checkMethod
			// 	})
			// },
			hide() {
				let $son_offer_goods = this.form.fApi.el('$son_offer_goods')
				let grid = $son_offer_goods.getGrid()
				if(grid.hideAction){
					grid.hideAction()
				}
				this.$emit('back')
			},
			checkUrl(value) {
				let httpreg = /^http/
				let httpsreg = /^https/
				if (httpreg.test(value) || httpsreg.test(value)) {
					return {
						id:this.getParam(value, 'id'),
						skuId:this.getParam(value, 'skuId')
					}
				}
			},
			getParam(value, paraName, def = null) {
				let url = value
				let arrObj = url.split("?")
				if (arrObj.length > 1) {
					let arrPara = arrObj[1].split("&")
					let arr;
					for (let i = 0; i < arrPara.length; i++) {
						arr = arrPara[i].split("=")
						if (arr != null && arr[0] == paraName) {
							return arr[1]
						}
					}
					return def
				} else {
					return def
				}
			}
		},
		components: {
			box,
			phonebox
		}
	}
</script>
